"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ten = exports.one = exports.ensureBigNumber = void 0;
const bignumber_js_1 = require("bignumber.js");
function ensureBigNumber(candidate) {
    let retVal;
    if (typeof candidate === 'number' || typeof candidate === 'string') {
        retVal = new bignumber_js_1.BigNumber(candidate);
    }
    else {
        if (bignumber_js_1.BigNumber.isBigNumber(candidate) === false) {
            retVal = new bignumber_js_1.BigNumber(candidate.toString());
        }
        else {
            retVal = new bignumber_js_1.BigNumber(candidate);
        }
    }
    if (retVal.isNaN()) {
        throw new Error(`Conversion for BigNumber failed`);
    }
    return retVal;
}
exports.ensureBigNumber = ensureBigNumber;
const one = new bignumber_js_1.BigNumber(1);
exports.one = one;
const ten = new bignumber_js_1.BigNumber(10);
exports.ten = ten;
//# sourceMappingURL=utils.js.map